module.exports = __webpack_public_path__ + "img/mopiWhiteSmall.927947bc.png";